// Components/Avatar/Avatar.js
//
// Reusable circular initials avatar. The background is the user's chosen color
// or an auto (deterministic) one. Used in the Navbar and the account page.

import React from 'react';
import { getInitial, avatarBg, textColorFor } from '../../utils/avatars';

const Avatar = ({ user, size = 40, onClick, style }) => {
  const label = user?.name || user?.email || '';
  const bg = avatarBg(user);
  return (
    <div
      onClick={onClick}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        background: bg,
        color: textColorFor(bg),
        fontWeight: 600,
        fontSize: Math.round(size * 0.45),
        cursor: onClick ? 'pointer' : undefined,
        ...style,
      }}
    >
      {getInitial(label)}
    </div>
  );
};

export default Avatar;
